export const DateOption = {
  flow: 'y', align: 'center center', padding: 'Y Z', round: 'Z', background: 'inkMid', border: '1px solid inkBorder', cursor: 'pointer', flex: '1', minWidth: '0',
  transition: 'all 0.15s ease',
  isSelected: (el, s) => s.root.selectedDate === s.value,
  '.isSelected': { background: '#0D1117', color: '#FFFFFF', borderColor: '#0D1117' },
  ':hover': { borderColor: '#0D1117' },
  onClick: (e, el, s) => s.root.update({ selectedDate: s.value }),
  DateLabel: { text: (el, s) => s.label, fontSize: 'Y', fontWeight: '600', textAlign: 'center', whiteSpace: 'nowrap' }
}
